export default "__VITE_ASSET__CFHWznvQ__"